import {ServiceBase} from '../ServiceBase';
import { action, observable, reaction, makeObservable } from 'mobx';
import {SEO_CATEGORIES} from '../../consts/seo-categories';
import {
  AiNewRecommendedGames,
  IAiNewGamesEngineService
} from "./ai-new-games.service.interface";
import {Check} from "@sparkware/app-utils";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";

export class AiNewGamesEngineService extends ServiceBase implements IAiNewGamesEngineService {

  constructor(services: IServiceFactoryExtended) {
    super(services);

    makeObservable(this);

    reaction(() => this.services.user.isAuthorized,
        () => {
          this._aiNewRecommendedGamesData = null;
        });
  }

  @observable.ref
  _aiNewRecommendedGamesData: AiNewRecommendedGames | null = null;
  private _isAINewRecommendedGamesUpdateInProgress = false;

  get aiNewRecommendedGames(): AiNewRecommendedGames | null {
    if (Check.isNullOrUndefined(this._aiNewRecommendedGamesData)) {
      this._updateAiNewRecommendedGames();
    }
    return this._aiNewRecommendedGamesData;
  }

  @action.bound
  private _setAiNewRecommendedGames(value: AiNewRecommendedGames) {

    let tempGameTypesMap = {};

    if (value.gameTypes) {
      value.gameTypes.forEach((gameType, i) => tempGameTypesMap[gameType] = i);
    }

    this._aiNewRecommendedGamesData = {...value, gameTypes: (value.gameTypes || []), gameTypesMap: tempGameTypesMap};
  }

  private async _updateAiNewRecommendedGames(): Promise<void> {
    if(this._isAINewRecommendedGamesUpdateInProgress) {
      return;
    }
    this._isAINewRecommendedGamesUpdateInProgress = true;
    try {
      if(this.services.user.isAuthorized) {
        let aiRecommendationsData = await this.services.sdk.getAINewRecommendations({filterOutRecentlyPlayedGames: true});
        this._setAiNewRecommendedGames({
          gameTypes: aiRecommendationsData?.gameTypes || [],
          engine: aiRecommendationsData?.engine
        });
      } else {
        // we need this setTimeout because _updateAiNewRecommendedGames is called from aiNewRecommendedGames getter
        // which in turn might be called from a computed observable and this doesn't like to mobx
        setTimeout(() => {
          this._setAiNewRecommendedGames({
            gameTypes: [],
            engine: ''
          });
        })

      }

      this._sendAINewRecommendationAnalytics();
    } finally {
       this._isAINewRecommendedGamesUpdateInProgress = false;
    }

  }

  private _sendAINewRecommendationAnalytics(): void {
    if(!this.aiNewRecommendedGames) {
      return;
    }

    let analyticsObject = this.aiNewRecommendedGames.gameTypes.reduce((result, gameType, index) => {
      result[gameType] = index;
      return result;
    }, {});


    this.services.analytics.sendElasticInfoEvent({
      category: SEO_CATEGORIES.AI_NEW_GAMES_RECOMMENDATIONS,
      action: JSON.stringify(analyticsObject),
      label: this.aiNewRecommendedGames.engine,
      eventType:"Orbit_AI_Feature"
    }, true);
  }
}
